// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SubtitleText_wrapper__7sqts","is_subtitle1":"SubtitleText_is_subtitle1__aDc3R","is_subtitle2":"SubtitleText_is_subtitle2__SDk_e"};